import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatStepperModule } from '@angular/material/stepper';
import { TranslateModule } from '@ngx-translate/core';
import { SignOffStepComponent } from '@data-terminal/feature-dialogs/components/sign-off-component.abstract';
import { SignOffMachine } from '@data-terminal/shared-models/machine';
import { isCurrentUserAnOperator } from '@data-terminal/utils/functions';
import { SignOffEmployeesCardModule } from '@data-terminal/feature-dialogs/components/sign-off-employees/sign-off-employees-card/sign-off-employees-card.component';
import { SignOffEmployees } from '@data-terminal/shared-models/dialogs/sign-off-dialog';

@Component({
    selector: 'data-terminal-sign-off-employees',
    templateUrl: './sign-off-employees.component.html',
    styleUrls: ['./sign-off-employees.component.scss'],
    standalone: false,
})
export class SignOffEmployeesComponent extends SignOffStepComponent<SignOffEmployees> {
    @Input() public userId!: string;

    public shouldDisplayCard(signOffData: SignOffMachine): boolean {
        return (
            signOffData.machine.signedOnUsers?.length > 1 && isCurrentUserAnOperator(signOffData.machine, this.userId)
        );
    }
}

@NgModule({
    declarations: [SignOffEmployeesComponent],
    exports: [SignOffEmployeesComponent],
    imports: [SignOffEmployeesCardModule, CommonModule, MatStepperModule, TranslateModule],
})
export class SignOffEmployeesModule {}
